import { HISTORY_BY_LEAVE_CARRYOVER_LIST, LEAVE_CARRYOVER_LIST, SET_PAGES } from "@/store/mutation-types";
import {
  convertObjectToParams,
  DATE_FORMAT_V2_DMY_HM,
  downloadFile,
  formatDateStringToString,
  getInfoStaff,
  getInfoStaffFull,
  PAGE_DEFAULT,
} from "@/utils";
import http from "../helpers/httpInterceptor";

const state = () => ({
  leaveCarryoverList: [],
  historyByLeaveCarryoverList: [],
  pages: PAGE_DEFAULT,
});

const mutations = {
  [LEAVE_CARRYOVER_LIST](states, data) {
    states.leaveCarryoverList = formatData(data);
  },
  [HISTORY_BY_LEAVE_CARRYOVER_LIST](states, data) {
    states.historyByLeaveCarryoverList = formatHistory(data);
  },
  [SET_PAGES](state, data) {
    state.pages = data;
  },
};

const actions = {
  getLeaveCarryoverList({ commit }, payload) {
    return http
      .get(`/tms/leaves-management/annual-leaves/reserve-leave${convertObjectToParams(payload)}`)
      .then((res) => {
        const {
          data,
          page: { page, size, total_element },
        } = res.data;
        commit(LEAVE_CARRYOVER_LIST, data ?? []);
        commit(SET_PAGES, {
          page,
          size,
          total: total_element,
        });
        return res.data;
      })
      .catch((error) => {
        commit(LEAVE_CARRYOVER_LIST, []);
        commit(SET_PAGES, PAGE_DEFAULT);
        throw error;
      });
  },
  addLeaveCarryover(_, payload) {
    return http
      .post(`/tms/leaves-management/annual-leaves/reserve-leave/create`, payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  editLeaveCarryover(_, payload) {
    return http
      .put(`/tms/leaves-management/annual-leaves/reserve-leave/update`, payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  deleteLeaveCarryover(_, payload) {
    const { id } = payload;
    return http
      .delete(`/tms/leaves-management/annual-leaves/reserve-leave/delete/${id}`)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  historyLeaveCarryover({ commit }, payload) {
    return http
      .get(`/tms/leaves-management/annual-leaves/reserve-leave/history${convertObjectToParams(payload)}`)
      .then((res) => {
        commit(HISTORY_BY_LEAVE_CARRYOVER_LIST, res.data.data);
        return res.data;
      })
      .catch((error) => {
        commit(HISTORY_BY_LEAVE_CARRYOVER_LIST, []);
        throw error;
      });
  },
  importLeaveCarryover(_, payload) {
    const formData = new FormData();
    formData.append("files", payload[0]);
    return http
      .post(`/tms/leaves-management/annual-leaves/reserve-leave/import`, formData, { responseType: "blob" })
      .then((res) => {
        const { filename, code } = res.headers;
        if (code != 200) {
          downloadFile(res.data, filename ?? "LeaveCarryover.xlsx", res.headers["content-type"]);
        }
        return res;
      })
      .catch((error) => {
        throw error;
      });
  },
  downloadTemplate() {
    return http
      .get(`/tms/leaves-management/annual-leaves/reserve-leave/template`, { responseType: "blob" })
      .then((res) => {
        const { filename } = res.headers;
        downloadFile(res.data, filename ?? "Template.xlsx", res.headers["content-type"]);
        return res;
      })
      .catch((error) => {
        throw error;
      });
  },
};

const formatData = (data) => {
  if (!data || data.length <= 0) return [];
  return data.map((item) => {
    const { employee, applyDate, expireDate } = item;
    return {
      ...item,
      fullName: getInfoStaffFull(employee),
      division: employee?.division_name?.name ?? "",
      applyDateFormat: formatDateStringToString(applyDate),
      expireDateFormat: formatDateStringToString(expireDate),
    };
  });
};

export const formatHistory = (data) => {
  if (!data || data.length <= 0) return [];
  return data?.map((item) => {
    const { new_record, createdDate, action } = item;
    return {
      ...item,
      createdDateFormat: formatDateStringToString(createdDate, DATE_FORMAT_V2_DMY_HM),
      new_record: {
        ...new_record,
        createdByName: `${new_record?.createdBy?.name ?? ""} - ${new_record?.createdBy?.departmentName ?? ""}`,
        createdDateFormat: formatDateStringToString(new_record?.createdDate, DATE_FORMAT_V2_DMY_HM),
        updatedBy: `${new_record?.modifiedBy?.name ?? ""} - ${new_record?.modifiedBy?.departmentName ?? ""}`,
        modifiedDateFormat: formatDateStringToString(new_record?.modifiedDate, DATE_FORMAT_V2_DMY_HM),
        fullName: getInfoStaff(new_record?.employee),
        projectName: new_record?.project?.projectName ?? "",
        applyDateFormat: formatDateStringToString(new_record?.applyDate),
        expireDateFormat: formatDateStringToString(new_record?.expireDate),
        action,
      },
    };
  });
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
